import { CONTENT_TYPES_UTF8 } from '@federa/const/media-types';
import type { StorageGatewayProxyConfig } from '@federa/types/http-api';

export const INTERNAL_API_ROUTES = {
	STORAGE_GATEWAY: '/api/internal/storage-gateway',
	CONVERSATIONS: '/api/internal/conversations',
	EXPLORE: '/api/internal/explore',
	HANDLE_FILES: '/api/internal/handle-files',
	STRIPE_PAYMENT: '/api/internal/stripe/payment-intent',
	// The payments-UI routes (ledger transactions/balance, refund, checkout, user-details) live on the payments-payouts MFE worker surface -- see PAYMENTS_PAYOUTS_API_ROUTES. The offers list route lives on the offers MFE.
} as const satisfies Record<string, `/api/internal/${string}`>;

export const STORAGE_GATEWAY_PROXY_CONFIG: StorageGatewayProxyConfig = {
	internalPrefix: INTERNAL_API_ROUTES.STORAGE_GATEWAY,
	serviceName: 'storage gateway',
	envOverrideKey: 'STORAGE_GATEWAY_API',
	notConfiguredError: 'Storage gateway endpoint is not configured',
	// No header modifier: the browser's own Authorization -- present or absent -- is forwarded untouched.
};

export const PROPERTY_FIND_ROUTE = '/api/internal/properties/find' as const;

export const PROPERTY_CREATE_ROUTE = '/api/internal/properties/create' as const;

export const ISSUE_CREATE_ROUTE = '/api/internal/issues/create' as const;

/* NO FLOW-RUN INGEST ROUTE: node-side run history reaches the warehouse as OTLP SPANS, which needs no internal route,
 * and no flow leaf exists for such a route to name. */

/** Default proxy content-type, composed from the canonical charset-suffixed media-type SSOT (`CONTENT_TYPES_UTF8.JSON` === 'application/json; charset=utf-8'). */
export const DEFAULT_PROXY_CONTENT_TYPE = CONTENT_TYPES_UTF8.JSON;

/** Synthetic internal URLs for Durable Object stub.fetch and service-binding fetches. The hostname is discarded by the far side -- only the path routes -- so these exist so the one synthetic origin per hop is spelled once. */
export const INTERNAL_URLS = {
	PROPERTY_DO_SUBSCRIBE: 'http://internal/subscribe',
	STORAGE_GATEWAY: 'https://storage-gateway.internal',
	/** Synthetic origin the Workers Cache API keys a server-computed JSON value under (`utils/cache/edge-json-cache.ts`).
	 *  Never fetched: the Cache API keys on a URL, and this one names no host that resolves. */
	EDGE_JSON_CACHE: 'https://edge-json-cache.internal',
} as const;
